import { Theme, css } from 'antd-style';
const globalStyles = ({ token }: { prefixCls: string; token: Theme }) => css`
  html,
  body,
  #__next {
    position: relative;

    overscroll-behavior: none;

    height: 100%;
    min-height: 100vh;
    max-height: 100vh;

    background: ${token.colorBgLayout};

    @media (max-width: 767px) {
      /* Mobile: Use dynamic viewport height to handle browser UI */
      height: 100dvh;
      min-height: 100dvh;
      max-height: 100dvh;
      overflow: hidden;
    }

    @media (min-device-width: 576px) {
      overflow: hidden;
    }
  }

  body {
    will-change: opacity;
    transform: translateZ(0);
    font-family: ${token.fontFamily};

    @media (max-width: 767px) {
      /* Prevent mobile browser UI from affecting layout */
      position: fixed;
      width: 100%;
      height: 100dvh;
      overflow: hidden;
    }
  }

  * {
    scrollbar-color: ${token.colorFill} transparent;
    scrollbar-width: thin;

    ::-webkit-scrollbar {
      width: 0.75em;
      height: 0.75em;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 10px;
    }

    :hover::-webkit-scrollbar-thumb {
      border: 3px solid transparent;
      background-color: ${token.colorText};
      background-clip: content-box;
    }

    ::-webkit-scrollbar-track {
      background-color: transparent;
    }
  }

  /* Force LTR direction for chat containers to keep scrollbars on the right */
  [data-virtuoso-scroller],
  .chat-container,
  .chat-list-container {
    direction: ltr !important;
  }

  /* Ensure chat content respects text direction while keeping scrollbar positioning */
  [data-virtuoso-scroller] * {
    direction: inherit;
  }

  /* Default pointer cursor for interactive controls (UX: cursor-pointer rule).
     Disabled / aria-disabled controls override to not-allowed. */
  button,
  summary,
  select,
  label[for],
  a[href],
  [role='button'],
  [role='tab'],
  [role='option'],
  [role='menuitem'],
  [role='switch'],
  [role='checkbox'],
  [role='radio'],
  input[type='button'],
  input[type='submit'],
  input[type='reset'],
  input[type='checkbox'],
  input[type='radio'],
  input[type='file'] {
    cursor: pointer;
  }

  button:disabled,
  select:disabled,
  input:disabled,
  [aria-disabled='true'],
  [data-disabled='true'],
  .ant-btn-disabled,
  .ant-btn[disabled] {
    cursor: not-allowed;
  }
`;

export default globalStyles;
